import React, { useRef, useState, useEffect } from 'react';
import { Button, Input, Space, Table } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import firebase from '../../config/firebase';
import perfilService from '../../service/perfil.service';
import CreateListPerfil from '../../view/perfil/CreateListPerfil';
import { useSelector } from "react-redux";
import Visibility from '@mui/icons-material/Visibility'

require('firebase/auth')

    export default function DataPerfilTable({ datas, onSave }) {

        const user = useSelector(state=> state.user);
        
        const db = firebase.firestore();

        const [showCreateModal, setShowCreateModal] = useState(false);
        const [recordEdit, setRecordEdit] = useState(null);
        const [refresh, setRefresh] = useState(false);
        const [data, setData] = useState(datas?.data);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            if (refresh) {
                fetchPerfis();
            };

            if (onSave > 0) {
                fetchPerfis();
            }
        }, [refresh, onSave]);

    useEffect(() => {

        fetchPerfis();

    }, []);

    async function fetchPerfis() {
        setLoading(true);
        try {
            const dataRefresh = await perfilService.getPerfis();

            let filteredPerfis = [];

            if (user.viewALL) {
                filteredPerfis = dataRefresh;
            } else {
                if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
                    const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
                    const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
                    const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

                    if (uids.length > 1) {
                        filteredPerfis = dataRefresh.filter(
                            (perfil) => perfil.uidShipper && uids.includes(perfil.uidShipper)
                        );
                    }
                    else {
                        filteredPerfis = dataRefresh.filter(
                            (perfil) => perfil.uidShipper === user?.uidShipper
                        );
                    }
                }
                else {
                    filteredPerfis = dataRefresh.filter(
                        (perfil) => perfil.uidShipper === user?.uidShipper
                    );
                }
            }

            setData(filteredPerfis);
            setLoading(false);
        } catch (error) {
            console.error("Erro ao buscar perfis:", error);
            setLoading(false);
        } finally {
            setRefresh(false);
        }
    }

    function handleSave(){
        setRefresh(true);
    }

    const navigate = useNavigate();

    async function deleteEmb(record) {
        let result = window.confirm("Deseja mesmo excluir esse Motorista ? ");
        if (result) {
            try {
                await perfilService.deletePerfil(record.id);
                alert("Perfil excluído com sucesso!");
                setRefresh(true);
            } catch (error) {
                console.error("Erro ao excluir perfil:", error);
                alert("Houve um erro ao excluir esse perfil!");
                setRefresh(true);
            }
        }
    }

    function handleEditClick(record) {
        let viewOnly = false;
        if (!user?.permissoes?.perfil?.isEdit) {
            viewOnly = true;
        }
        setRecordEdit(record);
        // setShowCreateModal(true);
        navigate('/createPerfil/' + record.id, { state: { record: record, viewOnly: viewOnly } });
    }

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'nomePerfil',
            key: 'nomePerfil',
        },
        {
            title: 'Ações',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {
                        user?.permissoes?.perfil?.isEdit ?
                        (
                            <EditOutlinedIcon style={{ color: '#1a73e8', cursor: 'pointer' }} onClick={() => handleEditClick(record)} />
                        )
                        :
                        (
                            <Visibility style={{ color: '#1a73e8', cursor: 'pointer' }} onClick={() => handleEditClick(record)} />
                        )
                    }
                    {
                        user?.permissoes?.perfil?.isDelete ? 
                        (
                            <Link to={'#'}>
                                <DeleteOutlinedIcon onClick={(e) => deleteEmb(record)} color='error'/>
                            </Link>
                        )
                        :
                        (
                            ""
                        )
                    }
                </Space>
            ),
        },
    ];

    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} />
            <CreateListPerfil 
                open={showCreateModal}
                onClose={() => {setShowCreateModal(false); setRecordEdit(null); setRefresh(true)}}
                record={recordEdit}
                onSaveChange={handleSave}
            />
        </>
    )
}